/**
 * A popup appearing under the Header's search input, encouraging users to search.
 * Rendered by the InterruptionChooser via a portal
 * Cadence determined by HeaderSearchPopup Dismissible.
 * Triggers a header_search_popup impression.
 */

import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import styled, { stylesheet } from 'astroturf/react';

import { TextButton } from 'js/design_system/TextButton';
import { ImpressionWatcher } from 'js/utils/impressions/ImpressionWatcher';
import useOnClickOutside from 'js/utils/hooks/useOnClickOutside';

const Container = styled.div`
  background-color: #0954d3;
  border-radius: 6px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.39628);
  color: #ffffff;
  display: none;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0.02em;
  position: absolute;
  top: var(--search-overlay-top, 39px);
  left: -48px;

  &.show {
    display: block;
  }

  &:before {
    position: absolute;
    top: -5px;
    left: 50%;
    content: '';
    transform: rotate(45deg);
    width: 18px;
    height: 18px;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.5);
  }

  &:after {
    position: absolute;
    top: -9px;
    left: 50%;
    content: '';
    border-right: 9px solid transparent;
    border-bottom: 9px solid #0954d3;
    border-left: 9px solid transparent;
  }
`;

const styles = stylesheet`
  .watcher {
    background-color: inherit;
    border-radius: 6px;
    display: flex;
    position: relative;
    justify-content: space-between;
    align-items: center;
    padding: 21px 22px 23px;
  }
`;

// TODO: css transition fade in/out
const SearchPopup = () => {
  const containerRef = useRef<HTMLDivElement>();

  const [show, setShow] = useState(true);
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'MutableRefObject<HTMLDivElement ... Remove this comment to see the full error message
  useOnClickOutside(containerRef, () => setShow(false));

  useEffect(() => {
    window.Aedu.Dismissibles.recordShow('HeaderSearchPopup');
    return;
  }, []);

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'SiteStats' does not exist on type 'typeo... Remove this comment to see the full error message
  const numMillionWorks = window.Aedu.SiteStats.paper_count_in_millions;

  return (
    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    <Container show={show} ref={containerRef}>
      <ImpressionWatcher
        className={styles.watcher}
        source="header_search_popup"
      >
        Search {numMillionWorks} million papers on Academia
        <TextButton
          icon="close"
          inverse
          inline
          onClick={() => {
            setShow(false);
            window.Aedu.Dismissibles.recordDismissal('HeaderSearchPopup');
          }}
        />
      </ImpressionWatcher>
    </Container>
  );
};

const SearchPopupPortal = () => {
  const searchInputPopupRoot = document.getElementById('nav--search-input');
  if (searchInputPopupRoot != null) {
    return ReactDOM.createPortal(<SearchPopup />, searchInputPopupRoot);
  }
  return null;
};

export default SearchPopupPortal;
